import React, { useMemo, useState } from "react";
import { News } from "../../pages";
import { NewsController } from "../../controllers";
import { useNavigate } from "react-router-dom";
import { adminStore } from "../../stores";
import constant from "../../utils/constant";

const NewsContainer = () => {
  const [createNewsModal, setCreateNewsModal] = useState(false);
  const [deleteNewsModal, setDeleteNewsModal] = useState(false);

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const newsTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = NewsController.useGetNews(
    newsTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const navigate = useNavigate();

  const goToCreateNews = () => {
    setCreateNewsModal(true);
  };
  const goToViewMore = () => {
    navigate(constant.Routes.ViewMoreNews);
  };
  const goToUpdateNews = () => {
    setCreateNewsModal(true);
  };
  const goToDeleteNews = () => {
    setDeleteNewsModal(true);
  };

  const closeModal = () => {
    adminStore.setSingleNews({});
    setCreateNewsModal(false);
    setDeleteNewsModal(false);
  };
  return (
    <News
      closeModal={closeModal}
      goToCreateNews={goToCreateNews}
      createNewsModal={createNewsModal}
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      goToUpdateNews={goToUpdateNews}
      goToViewMore={goToViewMore}
      goToDeleteNews={goToDeleteNews}
      deleteNewsModal={deleteNewsModal}
    />
  );
};

export default NewsContainer;
